import {Component} from '@angular/core';
import {DialogAdapter, DialogParams} from '../../models/dialog-param';

@Component({
  selector: 'app-modal-simple',
  template: `
    <p class="m-4">{{params.message}}</p>
  `,
  styles: ['p { white-space: pre-line; }']
})
export class ModalSimpleComponent implements DialogAdapter {
  params: DialogParams;

  constructor() {}

  onModalInit() {
  }

  getPayload(): any {
    return this.params.extraParams;
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/model-simple/modal-simple.component.ts